import { AppShell } from "@chef/feature-app-shell";

import { PreferenceQuizNudge } from "@chef/smart-components";
import { IPromotion, ISection, IWeekOption } from "@chef/feature-sanity";

import { WeekStatus } from "../lib/WeekStatus";
import { WeekOverviewExperimental } from "../lib/WeekOverviewExperimental/WeekOverviewExperimental";
import { CampaignDisclaimer } from "../lib/CampaignDisclaimer";

interface MainExperimentalProps {
  week: number;
  year: number;
  promotion: IPromotion | null;
  whyDeliveryChangeSection: ISection | null;
  weekOptions: IWeekOption[];
}

export const MainExperimental = ({
  week,
  year,
  promotion,
  whyDeliveryChangeSection,
}: MainExperimentalProps) => {
  return (
    <>
      <WeekStatus
        week={week}
        year={year}
        sanityData={whyDeliveryChangeSection}
      />

      <AppShell.Main grid className="pt-6 pb-12">
        <CampaignDisclaimer week={week} year={year} promotion={promotion} />

        <PreferenceQuizNudge />

        <WeekOverviewExperimental week={week} year={year} />
      </AppShell.Main>
    </>
  );
};
